import { Box, InputLabel, SxProps, TextField } from "@mui/material";
import customInputStyles from "global/components/CustomInput/CustomInput.styles";

interface CustomProps {
  autoFocus?: boolean;
  label?: any;
  placeHolder?: string;
  value?: string | number;
  onChange?: any;
  type?: string;
  name?: any;
  select?: boolean;
  onKeyPress?: any;
  InputProps?: any;
  error?: any;
  required?: boolean;
  InputLabelProps?: any;
  id?: string;
  sx?: SxProps;
  propsToInputElement?: any;
  disabled?: boolean;
  onBlur?: Function;
  onClick?: Function;
  helperText?: string;
  inputType?: string;
  multiline?: boolean;
  rows?: number;
}

const CustomInput = (props: CustomProps) => {
  const classes = customInputStyles;
  const { error = null } = props;

  return (
    <Box>
      <Box mb={1}>
        <InputLabel sx={classes.nameField} required={props.required}>
          {props.label}
        </InputLabel>
      </Box>
      <TextField
        autoFocus={props.autoFocus ?? false}
        sx={props.sx ? props.sx : classes.textField}
        fullWidth
        variant="outlined"
        id={props.id}
        placeholder={props.placeHolder}
        type={props.type}
        name={props.name}
        select={props.select}
        value={props.value}
        multiline={props.multiline}
        rows={props.rows}
        InputProps={props.InputProps}
        inputProps={props.propsToInputElement}
        onChange={props.onChange}
        onKeyPress={props.onKeyPress}
        required={props.required}
        onBlur={props.onBlur}
        onClick={props?.onClick}
        {...(error && { error: true, helperText: error })}
        disabled={props.disabled}
        helperText={props.helperText}
      />
    </Box>
  );
};

export default CustomInput;
